import { createRootRoute, Outlet } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { SetupLanding } from '~/app/managers';
import { Toaster } from '~/components/ui/sonner';
import { CoachCallHost } from '~/features/coach/coach-call';

/**
 * Every page, inside the providers the router wraps around it
 * (`~/app/root-providers.tsx`): who the person is, which business is open,
 * and the background sync.
 *
 * The toaster here is the window's, for the pages outside the shell (sign-in,
 * setup). Inside the shell every pane holds its own (the main box's and the
 * right panel's, `components/ui/sonner.tsx`), and this one steps aside.
 *
 * OS's live call is held here, above every gate (step 5.2): the setup pages,
 * the business's shell, and the splash the `/v1/me` reload puts up after a
 * setup's Create, which unmounts every setup page. Live mode carries on
 * through Create into the new business.
 */
function RootLayout(): ReactElement {
  return (
    <>
      <SetupLanding />
      <CoachCallHost>
        <Outlet />
      </CoachCallHost>
      <Toaster />
    </>
  );
}

export const Route = createRootRoute({ component: RootLayout });
